import { css, keyframes } from 'styled-components';

function glowAnimation(color) {
  return keyframes`
    0% { 
      box-shadow: 0 0 -15px 1px ${color}; 
    }
    50% { 
      box-shadow: 0 0 15px 1px ${color}; 
    }
    100% { 
      box-shadow: 0 0 -15px 1px ${color}; 
    }
  `;
}

export default function(color) {
  return css`
    box-shadow: none;
    animation: ${glowAnimation(color)} 3500ms infinite;
  `;
}
